module.exports = __webpack_public_path__ + "static/media/Bootstrap.35d246d9.svg";